import styled, { css } from 'styled-components';
import Text from 'components/Text';
import Title from 'components/Title';
import Button from 'components/Button';
import { colorVariables } from 'theme/variables';

export const MenuSettingsStyled = styled.div`
  position: relative;
`;

export const MenuShareStyled = styled.div`
  position: relative;
`;

export const BackgroundStyled = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: background 200ms ease-in-out;
  ${({ isVisible }) => css`
    background: rgba(0, 0, 0, ${isVisible ? 0.5 : 0});
  `};
  ${({ isTV, isDesktopEpgPresent }) =>
    isTV &&
    !isDesktopEpgPresent &&
    css`
      position: absolute;
      bottom: unset;
      height: 100vh;
      height: calc(var(--vh) * 100);
      z-index: 99;
    `};
`;

export const MenuRootStyled = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: transform 200ms ease-in-out;
  ${({ isVisible }) => css`
    transform: translateY(${isVisible ? 0 : 100}%);
  `};
`;

export const TitleWrapper = styled.div`
  height: 50px;
  border-bottom: solid #e5e5e5 1px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemsWrapper = styled.div`
  padding: 0 15px 0 15px;
  transition: height 150ms ease-in-out;
  overflow: hidden;
  ${({ height }) =>
    height !== null &&
    css`
      height: ${height}px;
    `};
`;

export const BackButtonWrapper = styled.div`
  height: 55px;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.24);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledText = styled(Text)``;

export const StyledTitle = styled(Title)`
  letter-spacing: 1px;
`;

export const CheckboxItemStyled = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 0;

  &:last-child {
    padding-bottom: 20px;
  }

  & input {
    display: none;
  }
`;

export const MenuItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ hasValue }) => css`
    height: ${hasValue ? 65 : 50}px;
  `};

  ${({ isBlocked }) =>
    isBlocked &&
    css`
      ${StyledText} {
        color: ${colorVariables.gray_cod};
        opacity: 0.3;
      }
      pointer-events: none;
    `};

  &:active {
    ${StyledText} {
      color: ${colorVariables.turquoise};
    }
  }
`;

export const BySubscriptionButton = styled(Button)`
  margin-top: 15px;
  width: 100%;
  box-shadow: 0 2px 2px 0 rgba(63, 211, 196, 0.45);
  border-radius: 2px;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  height: 100%;
`;

export const ShareItemStyled = styled.div`
  height: 60px;
  margin: 0 15px;
  display: flex;
  align-items: center;
  border-bottom: #e5e5e5 1px solid;
`;

export const ShareTextStyled = styled(Text)`
  width: calc(100% - 64px);
  display: flex;
  justify-content: center;
`;
